<template>
  <div class="page">
    <div class="top">
      <van-search
        v-model="keyword"
        placeholder="搜索家长姓名/手机号/学生姓名"
        shape="round"
        @search="onSearch"
      />

      <div class="date-filter">
        <div class="date-row">
          <span class="date-label">预约时间</span>
          <span class="date-value" @click="openDateRangePicker">{{ dateRange.bookingStartDate || "开始日期" }}</span>
          <span class="date-sep">-</span>
          <span class="date-value" @click="openDateRangePicker">{{ dateRange.bookingEndDate || "结束日期" }}</span>
          <span
            v-if="dateRange.bookingStartDate || dateRange.bookingEndDate"
            class="date-clear"
            @click="clearDateRange"
          >
            清空
          </span>
        </div>
      </div>

      <van-tabs v-model="statusTab" swipeable @change="onStatusChange">
        <van-tab title="全部" name="all" />
        <van-tab title="待邀约" name="0" />
        <van-tab title="已预约" name="1" />
        <van-tab title="已到店" name="2" />
        <van-tab title="已支付定金" name="3" />
        <van-tab title="已成交" name="4" />
        <van-tab title="已取消" name="5" />
      </van-tabs>
    </div>

    <div class="list">
      <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
        <van-list
          v-model="loading"
          :finished="finished"
          finished-text="没有更多了"
          :error.sync="loadError"
          error-text="加载失败，点击重试"
          @load="onLoad"
        >
          <div class="records-wrap">
            <van-empty
              v-if="items.length === 0 && !loading && !loadError"
              image="search"
              description="暂无数据"
              class="empty"
            />
            <div
              v-for="it in items"
              :key="it.id"
              :class="['card', 'booking-card', statusClass(it.status)]"
              @click="openDetail(it)"
            >
              <div class="booking-card-top">
                <div class="booking-student">
                  <span class="booking-student-name">{{ it.stuName || "-" }}</span>
                  <span class="booking-student-age" v-if="it.age !== undefined && it.age !== null && it.age !== ''">
                    {{ it.age }}岁
                  </span>
                  <span class="booking-student-gender" v-if="it.genderName">
                    {{ it.genderName }}
                  </span>
                </div>
                <van-tag type="default" :class="['status-tag', statusClass(it.status)]">
                  {{ statusText(it.status) }}
                </van-tag>
              </div>

              <div class="booking-parent">
                <span class="booking-parent-label">家长：</span>
                <span class="booking-parent-name">{{ it.name || "-" }}</span>
                <span class="booking-parent-sep"> </span>
                <span class="booking-parent-mobile">{{ it.mobile || "-" }}</span>
              </div>

              <div class="booking-remark" v-if="it.remark">
                {{ it.remark }}
              </div>

              <div class="flow-actions" @click.stop>
                <button
                  type="button"
                  class="flow-step"
                  :class="{ active: isFlowStepActive(it, 'booking') }"
                  @click="openInvite(it)"
                >
                  邀约
                </button>
                <button
                  type="button"
                  class="flow-step"
                  :class="{ active: isFlowStepActive(it, 'arrive') }"
                  @click="openCheckIn(it)"
                >
                  到店
                </button>
                <button
                  type="button"
                  class="flow-step"
                  :class="{ active: isFlowStepActive(it, 'deposit') }"
                  @click="openPayDeposit(it)"
                >
                  支付定金
                </button>
                <button
                  type="button"
                  class="flow-step"
                  :class="{ active: isFlowStepActive(it, 'complete') }"
                  @click="openComplete(it)"
                >
                  成单
                </button>
              </div>
            </div>
          </div>
        </van-list>
      </van-pull-refresh>
    </div>

    <div class="bottom-bar">
      <van-button type="primary" block round @click="openBooking">
        新增学员
      </van-button>
    </div>

    <van-dialog
      v-model="payDialog.show"
      title="支付定金"
      show-cancel-button
      :before-close="beforeClosePay"
    >
      <div class="dialog-body">
        <van-field
          v-model="payDialog.depositAmount"
          label="定金金额"
          placeholder="请输入定金金额"
          type="number"
        />
        <van-field
          readonly
          clickable
          label="支付时间"
          :value="payDialog.paidTime"
          placeholder="请选择支付时间"
          @click="paidTimePicker.show = true"
        />
      </div>
    </van-dialog>

    <van-popup
      v-model="detailDialog.show"
      position="bottom"
      round
      :z-index="4200"
      :style="{ height: '82vh' }"
    >
      <div class="detail-popup">
        <div class="detail-popup-head">
          <div class="detail-popup-title">学员详情</div>
          <van-icon name="cross" class="detail-popup-close" @click="detailDialog.show = false" />
        </div>

        <div class="detail-popup-scroll">
          <div class="detail-main-card">
            <van-tag type="default" :class="['status-tag', 'detail-main-status', statusClass(detailItem.status)]">
              {{ statusText(detailItem.status) }}
            </van-tag>
            <div class="detail-student">
              <div class="detail-avatar">{{ detailAvatarText }}</div>
              <div class="detail-student-meta">
                <div class="detail-student-name">{{ detailItem.stuName || "-" }}</div>
                <div class="detail-student-age-birth">
                  <span class="detail-student-age">{{ detailItem.age ? `${detailItem.age}岁` : "-" }}</span>
                  <span class="detail-student-birth">{{ detailItem.birthDate || "-" }}</span>
                </div>
                <div class="detail-student-gender">{{ detailItem.genderName || "-" }}</div>
              </div>
            </div>

            <div class="detail-kv">
              <span class="detail-kv-label">家长姓名</span>
              <span class="detail-kv-value">{{ detailItem.name || "-" }}</span>
            </div>
            <div class="detail-kv">
              <span class="detail-kv-label">联系电话</span>
              <span class="detail-kv-value">{{ detailItem.mobile || "-" }}</span>
            </div>
            <div class="detail-kv">
              <span class="detail-kv-label">渠道</span>
              <span class="detail-kv-value">{{ detailItem.channelTypeName || detailItem.channelType || "-" }}</span>
            </div>
          </div>

          <div class="detail-section-title">业务信息</div>
          <div class="detail-info-list">
            <div class="detail-kv">
              <span class="detail-kv-label">创建员工</span>
              <span class="detail-kv-value">{{ detailItem.statffName || "-" }}</span>
            </div>
            <div class="detail-kv">
              <span class="detail-kv-label">创建时间</span>
              <span class="detail-kv-value">{{ detailItem.createTime || "-" }}</span>
            </div>
            <div class="detail-kv">
              <span class="detail-kv-label">预约时间</span>
              <span class="detail-kv-value">{{ detailItem.bookingTime || "-" }}</span>
            </div>
            <div class="detail-kv" v-if="showArriveStepFields">
              <span class="detail-kv-label">接待时间</span>
              <span class="detail-kv-value">{{ detailItem.checkInTime || "-" }}</span>
            </div>
            <div class="detail-kv" v-if="showArriveStepFields">
              <span class="detail-kv-label">接待员工</span>
              <span class="detail-kv-value">{{ detailItem.hostStaffName || "-" }}</span>
            </div>
            <div class="detail-kv" v-if="showArriveStepFields">
              <span class="detail-kv-label">试听老师</span>
              <span class="detail-kv-value">{{ detailItem.trialTeacherName || "-" }}</span>
            </div>
            <div class="detail-kv" v-if="showDepositStepFields">
              <span class="detail-kv-label">定金金额</span>
              <span class="detail-kv-value">{{ formatAmountDisplay(detailItem.depositAmount) }}</span>
            </div>
            <div class="detail-kv" v-if="showDepositStepFields">
              <span class="detail-kv-label">支付时间</span>
              <span class="detail-kv-value">{{ detailItem.paidTime || "-" }}</span>
            </div>
            <div class="detail-kv" v-if="showCompleteStepFields">
              <span class="detail-kv-label">成单金额</span>
              <span class="detail-kv-value">{{ formatAmountDisplay(detailItem.amount) }}</span>
            </div>
            <div class="detail-kv" v-if="showCompleteStepFields">
              <span class="detail-kv-label">成单时间</span>
              <span class="detail-kv-value">{{ detailItem.completeTime || "-" }}</span>
            </div>
            <div class="detail-kv" v-if="showCompleteStepFields">
              <span class="detail-kv-label">课程名称</span>
              <span class="detail-kv-value">{{ detailItem.courseName || "-" }}</span>
            </div>
            <div class="detail-kv" v-if="showCompleteStepFields">
              <span class="detail-kv-label">主课老师</span>
              <span class="detail-kv-value">{{ detailItem.leadTeacherName || "-" }}</span>
            </div>
            <div class="detail-kv" v-if="showCompleteStepFields">
              <span class="detail-kv-label">副课老师</span>
              <span class="detail-kv-value">{{ detailAssistantTeacherNames }}</span>
            </div>
          </div>

          <div class="detail-section-title">备注</div>
          <div class="detail-remark-block">{{ detailItem.remark || "暂无备注" }}</div>
        </div>
        <div class="detail-actions">
          <van-button round block type="primary" plain @click="openUpdateFromDetail">
            修改
          </van-button>
          <van-button round block type="primary" class="theme-btn" @click="openAssignTeacher(detailItem)">
            分配老师
          </van-button>
          <van-button round block type="danger" plain @click="doCancelFromDetail">
            取消预定
          </van-button>
        </div>
      </div>
    </van-popup>

    <van-popup v-model="updateDialog.show" position="bottom" round :z-index="4220" :style="{ maxHeight: '82vh' }">
      <div class="update-popup-wrap">
        <div class="popup-head">
          <div class="popup-title">修改学员</div>
          <van-icon name="cross" class="popup-close" @click="updateDialog.show = false" />
        </div>
        <div class="update-popup-scroll">
        <van-field
          v-model.trim="updateDialog.form.stuName"
          label="学员名"
          placeholder="请输入学员名"
          required
          :rules="[{ required: true, message: '请输入学员名' }]"
        />
        <van-field
          readonly
          clickable
          label="出生日"
          :value="updateDialog.form.birthDate"
          placeholder="请选择出生日"
          @click="openUpdateTimePicker('birthDate', '选择出生日', 'date')"
        />
        <van-field :value="updateAgeDisplay" label="年龄" readonly />
        <van-field name="gender" label="性别">
          <template #input>
            <van-radio-group v-model="updateDialog.form.gender" direction="horizontal">
              <van-radio :name="1">男</van-radio>
              <van-radio :name="2">女</van-radio>
            </van-radio-group>
          </template>
        </van-field>
        <van-field
          v-model.trim="updateDialog.form.name"
          label="家长名"
          placeholder="请输入家长名"
          required
          :rules="[{ required: true, message: '请输入家长名' }]"
        />
        <van-field
          v-model.trim="updateDialog.form.mobile"
          label="手机号"
          placeholder="请输入手机号"
          required
          :rules="[{ required: true, message: '请输入手机号' }]"
        />
        <van-field
          readonly
          clickable
          label="渠道"
          :value="updateChannelTypeLabel"
          placeholder="请选择渠道"
          @click="openUpdateChannelPicker"
          required
          :rules="[{ required: true, message: '请选择渠道' }]"
        />
        <van-field
          v-model.trim="updateDialog.form.remark"
          label="备注"
          type="textarea"
          rows="2"
          autosize
          placeholder="选填"
        />
        <van-field
          v-if="updateCanBooking"
          readonly
          clickable
          label="预约时间"
          :value="updateDialog.form.bookingTime"
          placeholder="请选择预约时间"
          @click="openUpdateTimePicker('bookingTime', '选择预约时间')"
        />
        <van-field
          v-if="updateCanArrive"
          readonly
          clickable
          label="接待人"
          :value="updateHostStaffLabel"
          placeholder="请选择接待人"
          @click="openUpdateStaffPicker('hostStaffId', '选择接待人')"
        />
        <van-field
          v-if="updateCanArrive"
          readonly
          clickable
          label="试听老师"
          :value="updateTrialTeacherLabel"
          placeholder="请选择试听老师"
          @click="openUpdateStaffPicker('trialTeacherId', '选择试听老师')"
        />
        <van-field
          v-if="updateCanArrive"
          readonly
          clickable
          label="接待时间"
          :value="updateDialog.form.checkInTime"
          placeholder="请选择接待时间"
          @click="openUpdateTimePicker('checkInTime', '选择接待时间')"
        />
        <van-field
          v-if="updateCanDeposit"
          v-model="updateDialog.form.depositAmount"
          label="定金金额"
          placeholder="选填"
          type="number"
        />
        <van-field
          v-if="updateCanDeposit"
          readonly
          clickable
          label="支付时间"
          :value="updateDialog.form.paidTime"
          placeholder="请选择支付时间"
          @click="openUpdateTimePicker('paidTime', '选择支付时间')"
        />
        <van-field
          v-if="updateCanComplete"
          v-model="updateDialog.form.amount"
          label="成单金额"
          placeholder="选填"
          type="number"
        />
        <van-field
          v-if="updateCanComplete"
          readonly
          clickable
          label="成单时间"
          :value="updateDialog.form.completeTime"
          placeholder="请选择成单时间"
          @click="openUpdateTimePicker('completeTime', '选择成单时间')"
        />
        <van-field
          v-if="updateCanComplete"
          readonly
          clickable
          label="课程"
          :value="updateCourseLabel"
          placeholder="请选择课程"
          @click="openUpdateCoursePicker"
        />
        <van-field
          v-if="updateCanComplete"
          readonly
          clickable
          label="主课老师"
          :value="updateLeadTeacherLabel"
          placeholder="请选择主课老师"
          @click="openUpdateStaffPicker('leadTeacherId', '选择主课老师')"
        />
        <van-field
          v-if="updateCanComplete"
          readonly
          clickable
          label="副课老师"
          :value="updateAssistantTeacherLabels"
          placeholder="请选择副课老师"
          @click="openUpdateAssistantPopup"
        />
        </div>
        <div class="update-popup-actions">
          <van-button round block type="primary" class="theme-btn" :loading="updateSubmitting" @click="submitUpdate">
            保存
          </van-button>
        </div>
      </div>
    </van-popup>

    <van-popup v-model="updateChannelPicker.show" position="bottom">
      <van-picker
        show-toolbar
        title="选择渠道"
        :columns="channelOptions"
        @confirm="onConfirmUpdateChannel"
        @cancel="updateChannelPicker.show = false"
      />
    </van-popup>

    <van-popup v-model="updateStaffPicker.show" position="bottom">
      <van-search v-model.trim="updateStaffSearch.single" placeholder="搜索员工姓名" />
      <van-picker
        show-toolbar
        :title="updateStaffPicker.title || '选择员工'"
        :columns="filteredUpdateStaffOptions"
        @confirm="onConfirmUpdateStaff"
        @cancel="updateStaffPicker.show = false"
      />
    </van-popup>

    <van-popup v-model="updateAssistantPopup.show" position="bottom" round :style="{ height: '60%' }">
      <div class="assign-assistant-popup">
        <div class="popup-head">
          <div class="popup-title">选择副课老师</div>
          <van-icon name="cross" class="popup-close" @click="updateAssistantPopup.show = false" />
        </div>
        <van-search v-model.trim="updateStaffSearch.assistant" placeholder="搜索员工姓名" />
        <div class="assign-assistant-body">
          <van-checkbox-group v-model="updateDialog.form.assistantTeacherIds">
            <van-cell-group inset>
              <van-cell
                v-for="opt in filteredUpdateAssistantStaffOptions"
                :key="`update-assistant-${opt.value}`"
                clickable
                @click="toggleUpdateAssistant(opt.value)"
              >
                <template #title>{{ opt.text }}</template>
                <template #right-icon>
                  <van-checkbox :name="String(opt.value)" @click.stop />
                </template>
              </van-cell>
            </van-cell-group>
          </van-checkbox-group>
        </div>
        <div class="assign-assistant-actions">
          <van-button round block type="primary" class="theme-btn" @click="updateAssistantPopup.show = false">
            完成
          </van-button>
        </div>
      </div>
    </van-popup>

    <van-popup v-model="updateCoursePicker.show" position="bottom">
      <van-search v-model.trim="courseSearchKeyword" placeholder="搜索课程" />
      <van-picker
        show-toolbar
        title="选择课程"
        :columns="filteredCourseOptions"
        @confirm="onConfirmUpdateCourse"
        @cancel="updateCoursePicker.show = false"
      />
    </van-popup>

    <van-popup v-model="updateTimePicker.show" position="bottom">
      <van-datetime-picker
        :type="updateTimePicker.type"
        :title="updateTimePicker.title || '选择时间'"
        :value="updateTimePicker.value"
        :min-date="updateTimePicker.type === 'date' ? birthDateMinDate : undefined"
        :max-date="updateTimePicker.type === 'date' ? birthDateMaxDate : undefined"
        @confirm="onConfirmUpdateTime"
        @cancel="updateTimePicker.show = false"
      />
    </van-popup>

    <van-popup v-model="paidTimePicker.show" position="bottom">
      <van-datetime-picker
        type="datetime"
        title="选择支付时间"
        :value="paidTimePicker.value"
        @confirm="onConfirmPaidTime"
        @cancel="paidTimePicker.show = false"
      />
    </van-popup>

    <van-dialog
      v-model="completeDialog.show"
      title="成单"
      show-cancel-button
      :before-close="beforeCloseComplete"
    >
      <div class="dialog-body">
        <van-field
          v-model="completeDialog.amount"
          label="支付金额"
          placeholder="请输入支付金额"
          type="number"
        />
        <van-field
          readonly
          clickable
          label="课程"
          :value="courseLabel"
          placeholder="请选择课程"
          @click="openCoursePicker"
        />
        <van-field
          readonly
          clickable
          label="成单时间"
          :value="completeDialog.completeTime"
          placeholder="请选择成单时间"
          @click="completeTimePicker.show = true"
        />
      </div>
    </van-dialog>

    <van-popup v-model="coursePicker.show" position="bottom">
      <van-search v-model.trim="courseSearchKeyword" placeholder="搜索课程" />
      <van-picker
        show-toolbar
        title="选择课程"
        :columns="filteredCourseOptions"
        @confirm="onConfirmCourse"
        @cancel="coursePicker.show = false"
      />
    </van-popup>

    <van-popup v-model="completeTimePicker.show" position="bottom">
      <van-datetime-picker
        type="datetime"
        title="选择成单时间"
        :value="completeTimePicker.value"
        @confirm="onConfirmCompleteTime"
        @cancel="completeTimePicker.show = false"
      />
    </van-popup>

    <van-dialog
      v-model="assignDialog.show"
      title="分配老师"
      show-cancel-button
      :before-close="beforeCloseAssignTeacher"
    >
      <div class="dialog-body">
        <van-field
          readonly
          clickable
          label="主课老师"
          :value="assignLeadTeacherLabel"
          placeholder="请选择主课老师"
          @click="openAssignLeadTeacherPicker"
        />
        <van-field
          readonly
          clickable
          label="副课老师"
          :value="assignAssistantTeacherLabels"
          placeholder="请选择副课老师（可多选）"
          @click="openAssignAssistantTeacherPopup"
        />
      </div>
    </van-dialog>

    <van-popup v-model="assignLeadTeacherPicker.show" position="bottom">
      <van-search v-model.trim="staffSearch.lead" placeholder="搜索员工姓名" />
      <van-picker
        show-toolbar
        title="选择主课老师"
        :columns="filteredLeadStaffOptions"
        @confirm="onConfirmAssignLeadTeacher"
        @cancel="assignLeadTeacherPicker.show = false"
      />
    </van-popup>

    <van-popup v-model="assignAssistantTeacherPopup.show" position="bottom" round :style="{ height: '60%' }">
      <div class="assign-assistant-popup">
        <div class="popup-head">
          <div class="popup-title">选择副课老师</div>
          <van-icon name="cross" class="popup-close" @click="assignAssistantTeacherPopup.show = false" />
        </div>
        <van-search v-model.trim="staffSearch.assistant" placeholder="搜索员工姓名" />
        <div class="assign-assistant-body">
          <van-checkbox-group v-model="assignDialog.assistantTeacherIds">
            <van-cell-group inset>
              <van-cell
                v-for="opt in filteredAssistantStaffOptions"
                :key="`assistant-${opt.value}`"
                clickable
                @click="toggleAssistant(opt.value)"
              >
                <template #title>{{ opt.text }}</template>
                <template #right-icon>
                  <van-checkbox :name="opt.value" @click.stop />
                </template>
              </van-cell>
            </van-cell-group>
          </van-checkbox-group>
        </div>
        <div class="assign-assistant-actions">
          <van-button round block type="primary" class="theme-btn" @click="assignAssistantTeacherPopup.show = false">
            完成
          </van-button>
        </div>
      </div>
    </van-popup>

    <van-popup v-model="bookingPopup" position="bottom" round :z-index="4000" :style="{ height: '500px' }">
      <div class="booking-popup-wrap">
        <div class="popup-head">
          <div class="popup-title">新增学员</div>
          <van-icon name="cross" class="popup-close" @click="bookingPopup = false" />
        </div>
        <div class="booking-popup-scroll">
          <van-form @submit="submitBooking">
          <van-field
            v-model.trim="bookingForm.stuName"
            name="stuName"
            label="学员名"
            placeholder="请输入学员名"
            required
            :rules="[{ required: true, message: '请输入学员名' }]"
          />
        <van-field
          readonly
          clickable
          name="birthDate"
          label="出生日"
          :value="bookingForm.birthDate"
          placeholder="请选择出生日"
          @click="openBookingBirthDatePicker"
        />
        <van-field :value="bookingAgeDisplay" label="年龄" readonly />
          <van-field name="gender" label="性别">
            <template #input>
              <van-radio-group v-model="bookingForm.gender" direction="horizontal">
                <van-radio :name="1">男</van-radio>
                <van-radio :name="2">女</van-radio>
              </van-radio-group>
            </template>
          </van-field>
          <van-field
            v-model.trim="bookingForm.name"
            name="name"
            label="家长名"
            placeholder="请输入家长名"
            required
            :rules="[{ required: true, message: '请输入家长名' }]"
          />
          <van-field
            v-model.trim="bookingForm.mobile"
            name="mobile"
            label="手机号"
            placeholder="请输入手机号"
            required
            :rules="[{ required: true, message: '请输入手机号' }]"
          />
          <van-field
            readonly
            clickable
            name="channelType"
            label="渠道"
            :value="channelTypeLabel"
            placeholder="请选择渠道"
            @click="openChannelPicker"
            required
            :rules="[{ required: true, message: '请选择渠道' }]"
          />
          <van-field
            v-model.trim="bookingForm.remark"
            name="remark"
            label="备注"
            type="textarea"
            rows="2"
            autosize
            placeholder="选填"
          />
            <div class="booking-popup-actions">
              <van-button round block type="primary" class="theme-btn" native-type="submit" :loading="bookingSubmitting">
                提交
              </van-button>
            </div>
          </van-form>
        </div>
      </div>

      <van-popup v-model="channelPicker.show" position="bottom">
        <van-picker
          show-toolbar
          title="选择渠道"
          :columns="channelOptions"
          @confirm="onConfirmChannel"
          @cancel="channelPicker.show = false"
        />
      </van-popup>
      <van-popup v-model="bookingBirthDatePicker.show" position="bottom">
        <van-datetime-picker
          type="date"
          title="选择出生日"
          :value="bookingBirthDatePicker.value"
          :min-date="birthDateMinDate"
          :max-date="birthDateMaxDate"
          @confirm="onConfirmBookingBirthDate"
          @cancel="bookingBirthDatePicker.show = false"
        />
      </van-popup>
    </van-popup>

    <van-popup v-model="invitePopup.show" position="bottom" round :z-index="4050" :style="{ height: '260px' }">
      <div class="booking-popup-wrap">
        <div class="popup-head">
          <div class="popup-title">邀约</div>
          <van-icon name="cross" class="popup-close" @click="invitePopup.show = false" />
        </div>
        <div class="booking-popup-scroll">
          <van-form @submit="submitInvite">
            <van-field
              readonly
              clickable
              name="bookingTime"
              label="邀约时间"
              :value="inviteForm.bookingTime"
              placeholder="请选择邀约时间"
              required
              :rules="[{ required: true, message: '请选择邀约时间' }]"
              @click="inviteTimePicker.show = true"
            />
            <div class="booking-popup-actions">
              <van-button round block type="primary" class="theme-btn" native-type="submit" :loading="inviteSubmitting">
                提交
              </van-button>
            </div>
          </van-form>
        </div>
      </div>

      <van-popup v-model="inviteTimePicker.show" position="bottom">
        <van-datetime-picker
          type="datetime"
          title="选择邀约时间"
          :value="inviteTimePicker.value"
          @confirm="onConfirmInviteTime"
          @cancel="inviteTimePicker.show = false"
        />
      </van-popup>
    </van-popup>

    <van-popup v-model="checkInPopup.show" position="bottom" round :z-index="4100" :style="{ height: '300px' }">
      <div class="booking-popup-wrap">
        <div class="popup-head">
          <div class="popup-title">到店信息</div>
          <van-icon name="cross" class="popup-close" @click="checkInPopup.show = false" />
        </div>
        <div class="booking-popup-scroll">
          <van-form @submit="submitCheckIn">
            <van-field
              readonly
              clickable
              name="hostStaffId"
              label="接待人"
              :value="hostStaffLabel"
              placeholder="请选择接待人"
              @click="openHostStaffPicker"
              :rules="[{ required: true, message: '请选择接待人' }]"
            />
            <van-field
              readonly
              clickable
              name="trialTeacherId"
              label="试听老师"
              :value="trialTeacherLabel"
              placeholder="请选择试听老师"
              @click="openTrialTeacherPicker"
              :rules="[{ required: true, message: '请选择试听老师' }]"
            />
            <van-field
              readonly
              clickable
              name="checkInTime"
              label="接待时间"
              :value="checkInForm.checkInTime"
              placeholder="请选择接待时间"
              @click="checkInTimePicker.show = true"
              :rules="[{ required: true, message: '请选择接待时间' }]"
            />
            <div class="booking-popup-actions">
              <van-button round block type="primary" class="theme-btn" native-type="submit" :loading="checkInSubmitting">
                确认到店
              </van-button>
            </div>
          </van-form>
        </div>
      </div>

      <van-popup v-model="hostStaffPicker.show" position="bottom">
        <van-search v-model.trim="staffSearch.host" placeholder="搜索员工姓名" />
        <van-picker
          show-toolbar
          title="选择接待人"
          :columns="filteredHostStaffOptions"
          @confirm="onConfirmHostStaff"
          @cancel="hostStaffPicker.show = false"
        />
      </van-popup>

      <van-popup v-model="trialTeacherPicker.show" position="bottom">
        <van-search v-model.trim="staffSearch.trial" placeholder="搜索员工姓名" />
        <van-picker
          show-toolbar
          title="选择试听老师"
          :columns="filteredTrialStaffOptions"
          @confirm="onConfirmTrialTeacher"
          @cancel="trialTeacherPicker.show = false"
        />
      </van-popup>

      <van-popup v-model="checkInTimePicker.show" position="bottom">
        <van-datetime-picker
          type="datetime"
          title="选择接待时间"
          :value="checkInTimePicker.value"
          @confirm="onConfirmCheckInTime"
          @cancel="checkInTimePicker.show = false"
        />
      </van-popup>
    </van-popup>

    <van-calendar
      v-model="dateRangePickerShow"
      type="range"
      :min-date="dateRangePickerMinDate"
      :max-date="dateRangePickerMaxDate"
      :allow-same-day="true"
      :show-confirm="true"
      :default-date="dateRangePickerDefault"
      :z-index="5000"
      color="rgb(242, 124, 52)"
      @close="dateRangePickerShow = false"
      @confirm="onConfirmDateRange"
    />
  </div>
</template>

<script>
import { Toast, Dialog } from "vant"
import {
  fetchCustomerList,
  checkInCustomer,
  cancelBooking,
  payDeposit,
  createCustomerInput,
  bookingCustomer,
  updateCustomer,
  fetchDictionary,
  fetchStaffList,
  completeCustomer,
  assignTeacher
} from "@/api/customer"

const CHANNEL_DICT_TYPE_ID = 100
const COURSE_DICT_TYPE_ID = 102
const STAFF_PAGE_SIZE = 200

function pad2(n) {
  return String(n).padStart(2, "0")
}

function formatDateTime(d) {
  const yyyy = d.getFullYear()
  const mm = pad2(d.getMonth() + 1)
  const dd = pad2(d.getDate())
  const hh = pad2(d.getHours())
  const mi = pad2(d.getMinutes())
  const ss = pad2(d.getSeconds())
  return `${yyyy}-${mm}-${dd} ${hh}:${mi}:${ss}`
}

function formatDate(d) {
  const yyyy = d.getFullYear()
  const mm = pad2(d.getMonth() + 1)
  const dd = pad2(d.getDate())
  return `${yyyy}-${mm}-${dd}`
}

function parseDateSafe(v) {
  if (!v) return null
  const dt = new Date(String(v).replace(/-/g, "/"))
  return Number.isNaN(dt.getTime()) ? null : dt
}

function calcAgeByBirthDate(birthDate) {
  const birth = parseDateSafe(birthDate)
  if (!birth) return null
  const now = new Date()
  let age = now.getFullYear() - birth.getFullYear()
  const m = now.getMonth() - birth.getMonth()
  if (m < 0 || (m === 0 && now.getDate() < birth.getDate())) {
    age -= 1
  }
  return age >= 0 ? age : null
}

function getTenYearsAgoJan1() {
  const now = new Date()
  return new Date(now.getFullYear() - 10, 0, 1)
}

function getBirthDateMinDate() {
  return new Date(1900, 0, 1)
}

function getBirthDateMaxDate() {
  const now = new Date()
  now.setHours(23, 59, 59, 999)
  return now
}

function getEmptyRange() {
  return {
    bookingStartDate: "",
    bookingEndDate: ""
  }
}

function getNextDayNineAM() {
  const dt = new Date()
  dt.setDate(dt.getDate() + 1)
  dt.setHours(9, 0, 0, 0)
  return dt
}

export default {
  name: "CustomerTrackView",
  data() {
    return {
      keyword: "",
      statusTab: "all",

      page: 1,
      pageSize: 10,
      totalRecords: 0,

      items: [],
      loading: false,
      finished: false,
      refreshing: false,
      loadError: false,

      payDialog: {
        show: false,
        id: null,
        depositAmount: "",
        paidTime: ""
      },
      detailDialog: {
        show: false
      },
      detailItem: {},
      updateDialog: {
        show: false,
        form: {
          id: null,
          status: null,
          name: "",
          stuName: "",
          mobile: "",
          birthDate: "",
          age: "",
          gender: null,
          channelType: null,
          remark: "",
          bookingTime: "",
          hostStaffId: null,
          trialTeacherId: null,
          checkInTime: "",
          depositAmount: "",
          paidTime: "",
          amount: "",
          completeTime: "",
          courseId: null,
          leadTeacherId: null,
          assistantTeacherIds: []
        }
      },
      updateSubmitting: false,
      updateChannelPicker: {
        show: false
      },
      updateStaffPicker: {
        show: false,
        title: "",
        target: ""
      },
      updateAssistantPopup: {
        show: false
      },
      updateCoursePicker: {
        show: false
      },
      updateTimePicker: {
        show: false,
        title: "",
        target: "",
        type: "datetime",
        value: new Date()
      },
      updateStaffSearch: {
        single: "",
        assistant: ""
      },
      paidTimePicker: {
        show: false,
        value: new Date()
      },
      completeDialog: {
        show: false,
        id: null,
        amount: "",
        courseId: null,
        completeTime: ""
      },
      assignDialog: {
        show: false,
        id: null,
        leadTeacherId: null,
        assistantTeacherIds: []
      },
      assignLeadTeacherPicker: {
        show: false
      },
      assignAssistantTeacherPopup: {
        show: false
      },
      completeTimePicker: {
        show: false,
        value: new Date()
      },
      courseOptions: [],
      courseSearchKeyword: "",
      courseLoading: false,
      coursePicker: {
        show: false
      },

      bookingPopup: false,
      bookingSubmitting: false,
      bookingForm: {
        name: "",
        mobile: "",
        stuName: "",
        birthDate: "",
        age: "",
        gender: null,
        channelType: null,
        remark: ""
      },
      bookingBirthDatePicker: {
        show: false,
        value: getTenYearsAgoJan1()
      },
      birthDateMinDate: getBirthDateMinDate(),
      birthDateMaxDate: getBirthDateMaxDate(),
      invitePopup: {
        show: false,
        id: null
      },
      inviteSubmitting: false,
      inviteForm: {
        bookingTime: ""
      },
      inviteTimePicker: { show: false, value: new Date() },
      channelOptions: [],
      channelLoading: false,
      channelPicker: {
        show: false
      },

      checkInPopup: {
        show: false,
        customerId: null
      },
      checkInSubmitting: false,
      checkInForm: {
        hostStaffId: null,
        trialTeacherId: null,
        checkInTime: ""
      },
      staffOptions: [],
      staffSearch: {
        host: "",
        trial: "",
        lead: "",
        assistant: ""
      },
      staffLoading: false,
      hostStaffPicker: { show: false },
      trialTeacherPicker: { show: false },
      checkInTimePicker: { show: false, value: new Date() },

      dateRange: getEmptyRange(),
      dateRangePickerShow: false,
      dateRangePickerMinDate: new Date(1970, 0, 1),
      dateRangePickerMaxDate: new Date(2100, 11, 31),
      keywordTimer: null
    }
  },
  mounted() {
    this.onRefresh()
  },
  beforeDestroy() {
    if (this.keywordTimer) {
      clearTimeout(this.keywordTimer)
      this.keywordTimer = null
    }
  },
  watch: {
    keyword() {
      this.onKeywordInput()
    }
  },
  computed: {
    dateRangePickerDefault() {
      const start = this.dateRange.bookingStartDate
      const end = this.dateRange.bookingEndDate
      if (!start || !end) {
        const today = new Date()
        const tomorrow = new Date()
        tomorrow.setDate(today.getDate() + 1)
        return [today, tomorrow]
      }
      return [new Date(start.replace(/-/g, "/")), new Date(end.replace(/-/g, "/"))]
    },
    channelTypeLabel() {
      const v = this.bookingForm.channelType
      if (v === null || v === undefined || v === "") return ""
      const o = this.channelOptions.find(x => String(x.value) === String(v))
      return o ? o.text : ""
    },
    updateChannelTypeLabel() {
      const v = this.updateDialog.form.channelType
      if (v === null || v === undefined || v === "") return ""
      const o = this.channelOptions.find(x => String(x.value) === String(v))
      return o ? o.text : ""
    },
    bookingAgeDisplay() {
      const n = calcAgeByBirthDate(this.bookingForm.birthDate)
      return n === null ? "-" : `${n}岁`
    },
    updateAgeDisplay() {
      const n = calcAgeByBirthDate(this.updateDialog.form.birthDate)
      return n === null ? "-" : `${n}岁`
    },
    hostStaffLabel() {
      const v = this.checkInForm.hostStaffId
      if (v === null || v === undefined || v === "") return ""
      const o = this.staffOptions.find(x => String(x.value) === String(v))
      return o ? o.text : ""
    },
    trialTeacherLabel() {
      const v = this.checkInForm.trialTeacherId
      if (v === null || v === undefined || v === "") return ""
      const o = this.staffOptions.find(x => String(x.value) === String(v))
      return o ? o.text : ""
    },
    courseLabel() {
      const v = this.completeDialog.courseId
      if (v === null || v === undefined || v === "") return ""
      const o = this.courseOptions.find(x => String(x.value) === String(v))
      return o ? o.text : ""
    },
    assignLeadTeacherLabel() {
      const v = this.assignDialog.leadTeacherId
      if (v === null || v === undefined || v === "") return ""
      const o = this.staffOptions.find(x => String(x.value) === String(v))
      return o ? o.text : ""
    },
    assignAssistantTeacherLabels() {
      const ids = Array.isArray(this.assignDialog.assistantTeacherIds) ? this.assignDialog.assistantTeacherIds : []
      if (!ids.length) return ""
      const labels = this.staffOptions
        .filter(x => ids.some(id => String(id) === String(x.value)))
        .map(x => x.text)
      return labels.join("、")
    },
    filteredHostStaffOptions() {
      const kw = (this.staffSearch.host || "").trim()
      if (!kw) return this.staffOptions
      return this.staffOptions.filter(x => String(x.text || "").includes(kw))
    },
    filteredTrialStaffOptions() {
      const kw = (this.staffSearch.trial || "").trim()
      if (!kw) return this.staffOptions
      return this.staffOptions.filter(x => String(x.text || "").includes(kw))
    },
    filteredLeadStaffOptions() {
      const kw = (this.staffSearch.lead || "").trim()
      if (!kw) return this.staffOptions
      return this.staffOptions.filter(x => String(x.text || "").includes(kw))
    },
    filteredAssistantStaffOptions() {
      const kw = (this.staffSearch.assistant || "").trim()
      if (!kw) return this.staffOptions
      return this.staffOptions.filter(x => String(x.text || "").includes(kw))
    },
    updateStatusNum() {
      const s = Number(this.updateDialog.form.status)
      return Number.isFinite(s) ? s : -1
    },
    updateCanBooking() {
      return this.updateStatusNum >= 1
    },
    updateCanArrive() {
      return this.updateStatusNum >= 2
    },
    updateCanDeposit() {
      return this.updateStatusNum >= 3
    },
    updateCanComplete() {
      return this.updateStatusNum >= 4
    },
    updateHostStaffLabel() {
      const v = this.updateDialog.form.hostStaffId
      if (v === null || v === undefined || v === "") return ""
      const o = this.staffOptions.find(x => String(x.value) === String(v))
      return o ? o.text : ""
    },
    updateTrialTeacherLabel() {
      const v = this.updateDialog.form.trialTeacherId
      if (v === null || v === undefined || v === "") return ""
      const o = this.staffOptions.find(x => String(x.value) === String(v))
      return o ? o.text : ""
    },
    updateLeadTeacherLabel() {
      const v = this.updateDialog.form.leadTeacherId
      if (v === null || v === undefined || v === "") return ""
      const o = this.staffOptions.find(x => String(x.value) === String(v))
      return o ? o.text : ""
    },
    updateAssistantTeacherLabels() {
      const ids = Array.isArray(this.updateDialog.form.assistantTeacherIds) ? this.updateDialog.form.assistantTeacherIds : []
      if (!ids.length) return ""
      const labels = this.staffOptions
        .filter(x => ids.some(id => String(id) === String(x.value)))
        .map(x => x.text)
      return labels.join("、")
    },
    updateCourseLabel() {
      const v = this.updateDialog.form.courseId
      if (v === null || v === undefined || v === "") return ""
      const o = this.courseOptions.find(x => String(x.value) === String(v))
      return o ? o.text : ""
    },
    filteredCourseOptions() {
      const kw = (this.courseSearchKeyword || "").trim()
      if (!kw) return this.courseOptions
      return this.courseOptions.filter(x => String(x.text || "").includes(kw))
    },
    filteredUpdateStaffOptions() {
      const kw = (this.updateStaffSearch.single || "").trim()
      if (!kw) return this.staffOptions
      return this.staffOptions.filter(x => String(x.text || "").includes(kw))
    },
    filteredUpdateAssistantStaffOptions() {
      const kw = (this.updateStaffSearch.assistant || "").trim()
      if (!kw) return this.staffOptions
      return this.staffOptions.filter(x => String(x.text || "").includes(kw))
    },
    detailAvatarText() {
      const s = (this.detailItem.stuName || this.detailItem.name || "").trim()
      return s ? s.slice(0, 1) : "客"
    },
    detailAssistantTeacherNames() {
      const arr = this.detailItem.assistantTeacherNames
      if (Array.isArray(arr) && arr.length) return arr.join("、")
      return "-"
    },
    detailStatusNum() {
      const s = Number(this.detailItem.status)
      return Number.isFinite(s) ? s : -1
    },
    showArriveStepFields() {
      return this.detailStatusNum >= 2 && this.detailStatusNum <= 4
    },
    showTrialTeacherField() {
      return this.detailStatusNum === 2
    },
    showDepositStepFields() {
      return this.detailStatusNum >= 3 && this.detailStatusNum <= 4
    },
    showCompleteStepFields() {
      return this.detailStatusNum === 4
    }
  },
  methods: {
    formatAmountDisplay(v) {
      const n = Number(v)
      if (!Number.isFinite(n) || n <= 0) return "-"
      return `￥${n}`
    },
    statusText(status) {
      const map = {
        0: "待邀约",
        1: "已预约",
        2: "已到店",
        3: "已支付定金",
        4: "已成交",
        5: "已取消"
      }
      return map[status] || "-"
    },
    statusClass(status) {
      if (status === 0) return "status-pending"
      if (status === 1) return "status-booking"
      if (status === 2) return "status-arrive"
      if (status === 3) return "status-booking"
      if (status === 4) return "status-deal"
      if (status === 5) return "status-cancel"
      return ""
    },
    parseKeyword() {
      const kw = (this.keyword || "").trim()
      return { allName: kw }
    },
    currentStatus() {
      if (this.statusTab === "all") return null
      const n = Number(this.statusTab)
      return Number.isFinite(n) ? n : null
    },
    async fetchPage() {
      const { allName } = this.parseKeyword()
      const status = this.currentStatus()
      const { bookingStartDate, bookingEndDate } = this.dateRange

      const payload = {
        displayStart: this.page,
        displayLength: this.pageSize,
        allName,
        status,
        bookingStartDate: bookingStartDate || undefined,
        bookingEndDate: bookingEndDate || undefined
      }

      const res = await fetchCustomerList(payload)
      const list = Array.isArray(res?.data) ? res.data : []
      const total = res?.page?.totalRecords ?? 0

      this.totalRecords = total
      return list
    },
    async onLoad() {
      this.loadError = false
      try {
        const list = await this.fetchPage()
        if (this.refreshing) {
          this.items = []
          this.refreshing = false
        }
        this.items = this.items.concat(list)

        const noMore = list.length < this.pageSize
        this.finished = noMore
        this.page += 1
      } catch (e) {
        this.loadError = true
      } finally {
        this.loading = false
      }
    },
    onRefresh() {
      this.finished = false
      this.loading = true
      this.refreshing = true
      this.page = 1
      this.onLoad()
    },
    onSearch() {
      this.onRefresh()
    },
    onKeywordInput() {
      if (this.keywordTimer) {
        clearTimeout(this.keywordTimer)
      }
      this.keywordTimer = setTimeout(() => {
        this.onRefresh()
      }, 350)
    },
    onStatusChange() {
      this.onRefresh()
    },
    openDateRangePicker() {
      this.dateRangePickerShow = true
    },
    clearDateRange() {
      this.dateRange = getEmptyRange()
      this.onRefresh()
    },
    onConfirmDateRange(dates) {
      // 先关闭弹框，避免因回参格式差异导致弹框不收起
      this.dateRangePickerShow = false

      let start = null
      let end = null

      if (Array.isArray(dates) && dates.length >= 2) {
        start = dates[0]
        end = dates[1]
      } else if (dates && dates.startDate && dates.endDate) {
        start = dates.startDate
        end = dates.endDate
      }

      if (!start || !end) return

      const startDate = start instanceof Date ? start : new Date(start)
      const endDate = end instanceof Date ? end : new Date(end)
      this.dateRange.bookingStartDate = formatDate(startDate)
      this.dateRange.bookingEndDate = formatDate(endDate)
      this.onRefresh()
    },
    isFlowStepActive(it, step) {
      const s = Number(it?.status)
      if (!Number.isFinite(s)) return false
      if (step === "booking") return s >= 1
      if (step === "arrive") return s >= 2
      if (step === "deposit") return s >= 3
      if (step === "complete") return s >= 4
      return false
    },
    openDetail(it) {
      this.detailItem = { ...it }
      this.detailDialog.show = true
    },
    async openUpdateFromDetail() {
      await this.ensureStaffOptions()
      await this.ensureCourseOptions()
      await this.ensureChannelOptions()
      this.updateDialog.form = {
        id: this.detailItem.id ?? null,
        status: this.detailItem.status ?? null,
        name: (this.detailItem.name || "").trim(),
        stuName: (this.detailItem.stuName || "").trim(),
        mobile: (this.detailItem.mobile || "").trim(),
        birthDate: (this.detailItem.birthDate || "").trim(),
        age: this.detailItem.age === null || this.detailItem.age === undefined ? "" : String(this.detailItem.age),
        gender: this.detailItem.gender === null || this.detailItem.gender === undefined ? null : Number(this.detailItem.gender),
        channelType: this.detailItem.channelType ?? null,
        remark: (this.detailItem.remark || "").trim(),
        bookingTime: (this.detailItem.bookingTime || "").trim(),
        hostStaffId: this.detailItem.hostStaffId ?? null,
        trialTeacherId: this.detailItem.trialTeacherId ?? null,
        checkInTime: (this.detailItem.checkInTime || "").trim(),
        depositAmount:
          this.detailItem.depositAmount === null || this.detailItem.depositAmount === undefined
            ? ""
            : String(this.detailItem.depositAmount),
        paidTime: (this.detailItem.paidTime || "").trim(),
        amount: this.detailItem.amount === null || this.detailItem.amount === undefined ? "" : String(this.detailItem.amount),
        completeTime: (this.detailItem.completeTime || "").trim(),
        courseId: this.detailItem.courseId ?? null,
        leadTeacherId: this.detailItem.leadTeacherId ?? null,
        assistantTeacherIds: this.normalizeIdArray(this.detailItem.assistantTeacherIds)
      }
      this.updateDialog.show = true
    },
    async openUpdateChannelPicker() {
      await this.ensureChannelOptions()
      this.updateChannelPicker.show = true
    },
    onConfirmUpdateChannel(values, indexes) {
      const opt = this.pickOptionFromPicker(values, indexes, this.channelOptions)
      if (opt) this.updateDialog.form.channelType = opt.value
      this.updateChannelPicker.show = false
    },
    async openUpdateStaffPicker(target, title) {
      await this.ensureStaffOptions()
      if (!this.staffOptions.length) return Toast.fail("暂无员工列表")
      this.updateStaffSearch.single = ""
      this.updateStaffPicker.target = target
      this.updateStaffPicker.title = title
      this.updateStaffPicker.show = true
    },
    onConfirmUpdateStaff(values, indexes) {
      const opt = this.pickOptionFromPicker(values, indexes, this.filteredUpdateStaffOptions)
      if (opt && this.updateStaffPicker.target) {
        this.updateDialog.form[this.updateStaffPicker.target] = opt.value
      }
      this.updateStaffPicker.show = false
    },
    async openUpdateAssistantPopup() {
      await this.ensureStaffOptions()
      if (!this.staffOptions.length) return Toast.fail("暂无员工列表")
      this.updateStaffSearch.assistant = ""
      this.updateAssistantPopup.show = true
    },
    toggleUpdateAssistant(staffId) {
      const ids = Array.isArray(this.updateDialog.form.assistantTeacherIds) ? this.updateDialog.form.assistantTeacherIds : []
      const target = String(staffId)
      const idx = ids.findIndex(id => String(id) === target)
      if (idx >= 0) ids.splice(idx, 1)
      else ids.push(target)
      this.updateDialog.form.assistantTeacherIds = [...ids]
    },
    async openUpdateCoursePicker() {
      await this.ensureCourseOptions()
      if (!this.courseOptions.length) return Toast.fail("暂无课程选项")
      this.courseSearchKeyword = ""
      this.updateCoursePicker.show = true
    },
    onConfirmUpdateCourse(values, indexes) {
      const opt = this.pickOptionFromPicker(values, indexes, this.filteredCourseOptions)
      if (opt) this.updateDialog.form.courseId = opt.value
      this.updateCoursePicker.show = false
    },
    openUpdateTimePicker(target, title) {
      const raw = this.updateDialog.form[target]
      let base = target === "birthDate" ? getTenYearsAgoJan1() : new Date()
      if (raw) {
        const dt = new Date(raw)
        if (!Number.isNaN(dt.getTime())) base = dt
      }
      this.updateTimePicker.target = target
      this.updateTimePicker.title = title
      this.updateTimePicker.type = target === "birthDate" ? "date" : "datetime"
      this.updateTimePicker.value = base
      this.updateTimePicker.show = true
    },
    onConfirmUpdateTime(value) {
      const dt = value instanceof Date ? value : new Date(value)
      this.updateTimePicker.value = dt
      if (this.updateTimePicker.target) {
        this.updateDialog.form[this.updateTimePicker.target] =
          this.updateTimePicker.type === "date" ? formatDate(dt) : formatDateTime(dt)
      }
      this.updateTimePicker.show = false
    },
    openBookingBirthDatePicker() {
      const dt = parseDateSafe(this.bookingForm.birthDate) || getTenYearsAgoJan1()
      this.bookingBirthDatePicker.value = dt
      this.bookingBirthDatePicker.show = true
    },
    onConfirmBookingBirthDate(value) {
      const dt = value instanceof Date ? value : new Date(value)
      this.bookingBirthDatePicker.value = dt
      this.bookingForm.birthDate = formatDate(dt)
      this.bookingBirthDatePicker.show = false
    },
    async submitUpdate() {
      if (this.updateSubmitting) return
      const form = this.updateDialog.form || {}
      const id = form.id
      const name = (form.name || "").trim()
      const stuName = (form.stuName || "").trim()
      const mobile = (form.mobile || "").trim()
      const channelType = form.channelType
      if (!id) {
        Toast.fail("缺少ID")
        return
      }
      if (!stuName) {
        Toast.fail("请输入学员名")
        return
      }
      if (!mobile) {
        Toast.fail("请输入手机号")
        return
      }
      if (!name) {
        Toast.fail("请输入家长名")
        return
      }
      if (channelType === null || channelType === undefined || channelType === "") {
        Toast.fail("请选择渠道")
        return
      }
      const birthDate = (form.birthDate || "").trim()
      const ageNum = calcAgeByBirthDate(birthDate)
      const status = Number(form.status)
      const depositStr = (form.depositAmount || "").trim()
      const depositNum = depositStr === "" ? null : Number(depositStr)
      const amountStr = (form.amount || "").trim()
      const amountNum = amountStr === "" ? null : Number(amountStr)
      const payload = {
        id,
        name,
        stuName,
        mobile,
        birthDate: birthDate || undefined,
        channelType,
        remark: (form.remark || "").trim() || undefined,
        gender: form.gender || undefined
      }
      if (ageNum !== null) {
        payload.age = ageNum
      }
      if (status >= 1) {
        payload.bookingTime = (form.bookingTime || "").trim() || undefined
      }
      if (status >= 2) {
        payload.hostStaffId = form.hostStaffId || undefined
        payload.trialTeacherId = form.trialTeacherId || undefined
        payload.checkInTime = (form.checkInTime || "").trim() || undefined
      }
      if (status >= 3) {
        if (depositStr !== "" && Number.isFinite(depositNum)) payload.depositAmount = depositNum
        payload.paidTime = (form.paidTime || "").trim() || undefined
      }
      if (status >= 4) {
        if (amountStr !== "" && Number.isFinite(amountNum)) payload.amount = amountNum
        payload.completeTime = (form.completeTime || "").trim() || undefined
        payload.courseId = form.courseId || undefined
        payload.leadTeacherId = form.leadTeacherId || undefined
        payload.assistantTeacherIds = (Array.isArray(form.assistantTeacherIds) ? form.assistantTeacherIds : [])
          .filter(x => x !== null && x !== undefined && x !== "")
      }
      this.updateSubmitting = true
      Toast.loading({ message: "提交中...", forbidClick: true, duration: 0 })
      try {
        await updateCustomer(payload)
        Toast.clear()
        Toast.success("修改成功")
        this.updateDialog.show = false
        this.detailDialog.show = false
        this.onRefresh()
      } catch (e) {
        Toast.clear()
      } finally {
        this.updateSubmitting = false
      }
    },
    openInvite(it) {
      const nextDayNine = getNextDayNineAM()
      this.invitePopup.id = it.id
      this.inviteForm = {
        bookingTime: formatDateTime(nextDayNine)
      }
      this.inviteTimePicker.value = nextDayNine
      this.invitePopup.show = true
    },
    onConfirmInviteTime(value) {
      const dt = value instanceof Date ? value : new Date(value)
      this.inviteForm.bookingTime = formatDateTime(dt)
      this.inviteTimePicker.show = false
    },
    async submitInvite() {
      if (this.inviteSubmitting) return
      const id = this.invitePopup.id
      if (!id) return Toast.fail("缺少学员ID")
      const bookingTime = (this.inviteForm.bookingTime || "").trim()
      if (!bookingTime) return Toast.fail("请选择邀约时间")
      this.inviteSubmitting = true
      Toast.loading({ message: "提交中...", forbidClick: true, duration: 0 })
      try {
        await bookingCustomer({ id, bookingTime })
        Toast.clear()
        Toast.success("邀约成功")
        this.invitePopup.show = false
        this.onRefresh()
      } catch (e) {
        Toast.clear()
      } finally {
        this.inviteSubmitting = false
      }
    },
    normalizeStaffRows(raw) {
      let list = []
      if (Array.isArray(raw)) list = raw
      else if (raw && Array.isArray(raw.data)) list = raw.data
      else if (raw && Array.isArray(raw.list)) list = raw.list
      else if (raw && Array.isArray(raw.records)) list = raw.records
      return list
        .map(item => {
          const text = item.weName ?? item.name ?? item.label ?? ""
          const value = item.id
          return { text: String(text), value }
        })
        .filter(x => x.text && x.value !== undefined && x.value !== null && x.value !== "")
    },
    async ensureStaffOptions() {
      if (this.staffOptions.length || this.staffLoading) return
      this.staffLoading = true
      try {
        const res = await fetchStaffList({ displayStart: 1, displayLength: STAFF_PAGE_SIZE })
        this.staffOptions = this.normalizeStaffRows(res)
      } finally {
        this.staffLoading = false
      }
    },
    pickOptionFromPicker(values, indexes, options) {
      if (Number.isInteger(indexes) && options[indexes]) return options[indexes]
      if (Array.isArray(indexes) && indexes.length && options[indexes[0]]) return options[indexes[0]]
      if (Array.isArray(values) && values.length) {
        const v = values[0]
        if (v && typeof v === "object" && "value" in v) return v
        return options.find(o => String(o.value) === String(v) || String(o.text) === String(v)) || null
      }
      if (values && typeof values === "object" && "value" in values) return values
      if (values !== undefined && values !== null && values !== "") {
        return options.find(o => String(o.value) === String(values) || String(o.text) === String(values)) || null
      }
      return null
    },
    async openCheckIn(it) {
      await this.ensureStaffOptions()
      if (!this.staffOptions.length) {
        Toast.fail("暂无员工列表")
        return
      }
      const now = new Date()
      this.checkInPopup.customerId = it.id
      this.checkInForm = {
        hostStaffId: null,
        trialTeacherId: null,
        checkInTime: formatDateTime(now)
      }
      this.checkInTimePicker.value = now
      this.checkInPopup.show = true
    },
    async openHostStaffPicker() {
      await this.ensureStaffOptions()
      if (!this.staffOptions.length) return Toast.fail("暂无员工列表")
      this.staffSearch.host = ""
      this.hostStaffPicker.show = true
    },
    async openTrialTeacherPicker() {
      await this.ensureStaffOptions()
      if (!this.staffOptions.length) return Toast.fail("暂无员工列表")
      this.staffSearch.trial = ""
      this.trialTeacherPicker.show = true
    },
    onConfirmHostStaff(values, indexes) {
      const opt = this.pickOptionFromPicker(values, indexes, this.filteredHostStaffOptions)
      if (opt) this.checkInForm.hostStaffId = opt.value
      this.hostStaffPicker.show = false
    },
    onConfirmTrialTeacher(values, indexes) {
      const opt = this.pickOptionFromPicker(values, indexes, this.filteredTrialStaffOptions)
      if (opt) this.checkInForm.trialTeacherId = opt.value
      this.trialTeacherPicker.show = false
    },
    onConfirmCheckInTime(value) {
      const dt = value instanceof Date ? value : new Date(value)
      this.checkInTimePicker.value = dt
      this.checkInForm.checkInTime = formatDateTime(dt)
      this.checkInTimePicker.show = false
    },
    async submitCheckIn() {
      if (this.checkInSubmitting) return
      const customerId = this.checkInPopup.customerId
      if (!customerId) return Toast.fail("缺少家长ID")
      const payload = {
        id: customerId,
        hostStaffId: this.checkInForm.hostStaffId,
        trialTeacherId: this.checkInForm.trialTeacherId,
        checkInTime: this.checkInForm.checkInTime
      }
      this.checkInSubmitting = true
      Toast.loading({ message: "提交中...", forbidClick: true, duration: 0 })
      try {
        await checkInCustomer(payload)
        Toast.clear()
        Toast.success("已到店")
        this.checkInPopup.show = false
        this.onRefresh()
      } catch (e) {
        Toast.clear()
      } finally {
        this.checkInSubmitting = false
      }
    },
    openPayDeposit(it) {
      const now = new Date()
      this.payDialog.id = it.id
      this.payDialog.depositAmount = it.depositAmount ? String(it.depositAmount) : ""
      this.payDialog.paidTime = formatDateTime(now)
      this.paidTimePicker.value = now
      this.payDialog.show = true
    },
    onConfirmPaidTime(value) {
      const dt = value instanceof Date ? value : new Date(value)
      this.paidTimePicker.value = dt
      this.payDialog.paidTime = formatDateTime(dt)
      this.paidTimePicker.show = false
    },
    async beforeClosePay(action, done) {
      if (action !== "confirm") {
        done()
        return
      }
      const id = this.payDialog.id
      const amount = Number(this.payDialog.depositAmount)
      const paidTime = this.payDialog.paidTime
      if (!id) {
        Toast.fail("缺少家长ID")
        done(false)
        return
      }
      if (!Number.isFinite(amount) || amount <= 0) {
        Toast.fail("请输入正确的定金金额")
        done(false)
        return
      }
      if (!paidTime) {
        Toast.fail("请选择支付时间")
        done(false)
        return
      }
      Toast.loading({ message: "提交中...", forbidClick: true, duration: 0 })
      try {
        await payDeposit({ id, depositAmount: amount, paidTime })
        Toast.clear()
        Toast.success("支付成功")
        done()
        this.onRefresh()
      } catch (e) {
        Toast.clear()
        done(false)
      }
    },
    async ensureCourseOptions() {
      if (this.courseOptions.length || this.courseLoading) return
      this.courseLoading = true
      try {
        const res = await fetchDictionary(COURSE_DICT_TYPE_ID)
        this.courseOptions = this.normalizeDictionaryRows(res)
      } finally {
        this.courseLoading = false
      }
    },
    async openCoursePicker() {
      await this.ensureCourseOptions()
      if (!this.courseOptions.length) {
        Toast.fail("暂无课程选项")
        return
      }
      this.courseSearchKeyword = ""
      this.coursePicker.show = true
    },
    onConfirmCourse(values, indexes) {
      const opt = this.pickOptionFromPicker(values, indexes, this.filteredCourseOptions)
      if (opt) this.completeDialog.courseId = opt.value
      this.coursePicker.show = false
    },
    onConfirmCompleteTime(value) {
      const dt = value instanceof Date ? value : new Date(value)
      this.completeTimePicker.value = dt
      this.completeDialog.completeTime = formatDateTime(dt)
      this.completeTimePicker.show = false
    },
    normalizeIdArray(value) {
      if (Array.isArray(value)) {
        return value.filter(x => x !== null && x !== undefined && x !== "").map(x => String(x))
      }
      if (value === null || value === undefined || value === "") return []
      if (typeof value === "string") {
        const s = value.trim()
        if (!s) return []
        if (s.startsWith("[") && s.endsWith("]")) {
          try {
            const parsed = JSON.parse(s)
            return Array.isArray(parsed)
              ? parsed.filter(x => x !== null && x !== undefined && x !== "").map(x => String(x))
              : []
          } catch (e) {
            // ignore
          }
        }
        return s
          .split(",")
          .map(x => x.trim())
          .filter(Boolean)
          .map(x => String(x))
      }
      return []
    },
    getStaffNameById(staffId) {
      const hit = this.staffOptions.find(x => String(x.value) === String(staffId))
      return hit ? hit.text : ""
    },
    applyAssignTeacherToLocal(id, leadTeacherId, assistantTeacherIds) {
      const nextAssistantIds = (Array.isArray(assistantTeacherIds) ? assistantTeacherIds : [])
        .filter(x => x !== null && x !== undefined && x !== "")
      const nextLeadName = this.getStaffNameById(leadTeacherId)
      const nextAssistantNames = nextAssistantIds.map(x => this.getStaffNameById(x)).filter(Boolean)

      this.items = this.items.map(it => {
        if (String(it.id) !== String(id)) return it
        return {
          ...it,
          leadTeacherId,
          assistantTeacherIds: [...nextAssistantIds],
          leadTeacherName: nextLeadName || it.leadTeacherName,
          assistantTeacherNames: nextAssistantNames.length ? nextAssistantNames : it.assistantTeacherNames
        }
      })

      if (String(this.detailItem?.id) === String(id)) {
        this.detailItem = {
          ...this.detailItem,
          leadTeacherId,
          assistantTeacherIds: [...nextAssistantIds],
          leadTeacherName: nextLeadName || this.detailItem.leadTeacherName,
          assistantTeacherNames: nextAssistantNames.length ? nextAssistantNames : this.detailItem.assistantTeacherNames
        }
      }
    },
    async openAssignTeacher(it) {
      await this.ensureStaffOptions()
      if (!this.staffOptions.length) {
        Toast.fail("暂无员工列表")
        return
      }
      this.assignDialog = {
        show: true,
        id: it.id,
        leadTeacherId: it.leadTeacherId ?? null,
        assistantTeacherIds: this.normalizeIdArray(it.assistantTeacherIds)
      }
    },
    async openAssignLeadTeacherPicker() {
      await this.ensureStaffOptions()
      if (!this.staffOptions.length) return Toast.fail("暂无员工列表")
      this.staffSearch.lead = ""
      this.assignLeadTeacherPicker.show = true
    },
    onConfirmAssignLeadTeacher(values, indexes) {
      const opt = this.pickOptionFromPicker(values, indexes, this.filteredLeadStaffOptions)
      if (opt) this.assignDialog.leadTeacherId = opt.value
      this.assignLeadTeacherPicker.show = false
    },
    async openAssignAssistantTeacherPopup() {
      await this.ensureStaffOptions()
      if (!this.staffOptions.length) return Toast.fail("暂无员工列表")
      this.staffSearch.assistant = ""
      this.assignAssistantTeacherPopup.show = true
    },
    toggleAssistant(staffId) {
      const ids = Array.isArray(this.assignDialog.assistantTeacherIds) ? this.assignDialog.assistantTeacherIds : []
      const idx = ids.findIndex(id => String(id) === String(staffId))
      if (idx >= 0) ids.splice(idx, 1)
      else ids.push(staffId)
      this.assignDialog.assistantTeacherIds = [...ids]
    },
    async beforeCloseAssignTeacher(action, done) {
      if (action !== "confirm") {
        done()
        return
      }
      const id = this.assignDialog.id
      const leadTeacherId = this.assignDialog.leadTeacherId
      const assistantTeacherIds = (Array.isArray(this.assignDialog.assistantTeacherIds) ? this.assignDialog.assistantTeacherIds : [])
        .filter(x => x !== null && x !== undefined && x !== "")
      if (!id) return done(false)
      if (leadTeacherId === null || leadTeacherId === undefined || leadTeacherId === "") {
        Toast.fail("请选择主课老师")
        done(false)
        return
      }
      const payload = {
        id,
        leadTeacherId,
        assistantTeacherIds
      }
      Toast.loading({ message: "提交中...", forbidClick: true, duration: 0 })
      try {
        await assignTeacher(payload)
        this.applyAssignTeacherToLocal(id, leadTeacherId, assistantTeacherIds)
        Toast.clear()
        Toast.success("分配成功")
        done()
        this.assignAssistantTeacherPopup.show = false
        this.onRefresh()
      } catch (e) {
        Toast.clear()
        done(false)
      }
    },
    async openComplete(it) {
      await this.ensureCourseOptions()
      if (!this.courseOptions.length) {
        Toast.fail("暂无课程选项")
        return
      }
      const now = new Date()
      this.completeDialog = {
        show: true,
        id: it.id,
        amount: "",
        courseId: null,
        completeTime: formatDateTime(now)
      }
      this.completeTimePicker.value = now
    },
    async beforeCloseComplete(action, done) {
      if (action !== "confirm") {
        done()
        return
      }
      const id = this.completeDialog.id
      const amount = Number(this.completeDialog.amount)
      const courseId = this.completeDialog.courseId
      const completeTime = this.completeDialog.completeTime
      if (!id) return done(false)
      if (!Number.isFinite(amount) || amount <= 0) {
        Toast.fail("请输入正确的支付金额")
        done(false)
        return
      }
      if (courseId === null || courseId === undefined || courseId === "") {
        Toast.fail("请选择课程")
        done(false)
        return
      }
      if (!completeTime) {
        Toast.fail("请选择成单时间")
        done(false)
        return
      }
      Toast.loading({ message: "提交中...", forbidClick: true, duration: 0 })
      try {
        await completeCustomer({ id, amount, courseId, completeTime })
        Toast.clear()
        Toast.success("成单成功")
        done()
        this.onRefresh()
      } catch (e) {
        Toast.clear()
        done(false)
      }
    },
    async doCancel(it) {
      await Dialog.confirm({
        title: "确认取消预定？",
        message: `${it.name || "-"}（${it.mobile || "-"}）`
      })
      Toast.loading({ message: "提交中...", forbidClick: true, duration: 0 })
      try {
        await cancelBooking(it.id)
        Toast.clear()
        Toast.success("已取消")
        this.onRefresh()
        return true
      } catch (e) {
        Toast.clear()
        return false
      }
    },
    async doCancelFromDetail() {
      const ok = await this.doCancel(this.detailItem)
      if (ok) this.detailDialog.show = false
    },
    normalizeDictionaryRows(raw) {
      let list = []
      if (Array.isArray(raw)) list = raw
      else if (raw && Array.isArray(raw.data)) list = raw.data
      else if (raw && Array.isArray(raw.list)) list = raw.list
      else if (raw && Array.isArray(raw.records)) list = raw.records
      return list
        .map(item => {
          // 渠道字典优先按 { code, value } 解析：展示 value，提交 code
          const text =
            item.value ?? item.name ?? item.label ?? item.dictLabel ?? item.text ?? item.title ?? ""
          const value = item.code ?? item.dictValue ?? item.id ?? item.key ?? item.value
          return { text: String(text), value }
        })
        .filter(
          x =>
            x.text !== "" &&
            x.value !== undefined &&
            x.value !== null &&
            x.value !== ""
        )
    },
    async ensureChannelOptions() {
      if (this.channelOptions.length || this.channelLoading) return
      this.channelLoading = true
      try {
        const res = await fetchDictionary(CHANNEL_DICT_TYPE_ID)
        this.channelOptions = this.normalizeDictionaryRows(res)
      } finally {
        this.channelLoading = false
      }
    },
    async openChannelPicker() {
      await this.ensureChannelOptions()
      if (!this.channelOptions.length) {
        Toast.fail("暂无渠道选项")
        return
      }
      this.channelPicker.show = true
    },
    onConfirmChannel(values, indexes) {
      let opt = null
      if (Number.isInteger(indexes) && this.channelOptions[indexes]) {
        opt = this.channelOptions[indexes]
      } else if (Array.isArray(indexes) && indexes.length && this.channelOptions[indexes[0]]) {
        opt = this.channelOptions[indexes[0]]
      } else if (Array.isArray(values) && values.length) {
        const v = values[0]
        if (v && typeof v === "object" && "value" in v) opt = v
        else opt = this.channelOptions.find(o => String(o.value) === String(v))
      } else if (values && typeof values === "object" && "value" in values) {
        opt = values
      } else if (values !== undefined && values !== null && values !== "") {
        opt = this.channelOptions.find(o => String(o.value) === String(values) || String(o.text) === String(values))
      }
      if (opt) this.bookingForm.channelType = opt.value
      this.channelPicker.show = false
    },
    openBooking() {
      this.bookingPopup = true
      this.bookingForm = {
        name: "",
        mobile: "",
        stuName: "",
        birthDate: "",
        age: "",
        gender: null,
        channelType: null,
        remark: ""
      }
      this.ensureChannelOptions()
    },
    async submitBooking() {
      if (this.bookingSubmitting) return
      const birthDate = (this.bookingForm.birthDate || "").trim()
      const ageNum = calcAgeByBirthDate(birthDate)
      const parentName = (this.bookingForm.name || "").trim()
      const payload = {
        name: parentName,
        mobile: this.bookingForm.mobile,
        stuName: (this.bookingForm.stuName || "").trim(),
        birthDate: birthDate || undefined,
        channelType: this.bookingForm.channelType,
        remark: (this.bookingForm.remark || "").trim() || undefined,
        gender: this.bookingForm.gender || undefined
      }
      if (!parentName) {
        Toast.fail("请输入家长名")
        return
      }
      if (!payload.stuName) {
        Toast.fail("请输入学员名")
        return
      }
      if (ageNum !== null) {
        payload.age = ageNum
      }
      this.bookingSubmitting = true
      Toast.loading({ message: "提交中...", forbidClick: true, duration: 0 })
      try {
        await createCustomerInput(payload)
        Toast.clear()
        Toast.success("新增成功")
        this.bookingPopup = false
        this.onRefresh()
      } catch (e) {
        Toast.clear()
      } finally {
        this.bookingSubmitting = false
      }
    }
  }
}
</script>

<style scoped>
.page {
  min-height: 100vh;
  background: #f7f8fa;
  --mg-orange: rgb(242, 124, 52);
  --mg-green: rgb(146, 186, 63);
  --mg-pink: rgb(214, 93, 140);
  --mg-cyan: rgb(74, 178, 194);
}

.top {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1200;
  background: #fff;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.04);
}

.date-filter {
  padding: 0 12px 4px;
  background: #fff;
}

.date-row {
  display: flex;
  align-items: center;
  gap: 4px;
  height: 24px;
  padding: 0 2px;
}

.date-label {
  font-size: 13px;
  color: #969799;
  flex: 0 0 auto;
}

.date-value {
  font-size: 13px;
  color: #323233;
  padding: 1px 5px;
  border-radius: 6px;
  background: #f7f8fa;
}

.date-sep {
  color: #969799;
  flex: 0 0 auto;
}

.date-clear {
  margin-left: 6px;
  font-size: 12px;
  color: rgb(242, 124, 52);
  flex: 0 0 auto;
}

.list {
  padding-top: 124px; /* fixed top area height */
  padding-bottom: 100px; /* action-bar + safe-area */
}

.records-wrap {
  margin-top: 8px;
  padding: 0 12px;
}

.empty {
  padding: 44px 0;
  background: transparent;
}

.bottom-bar {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  padding: 10px 12px;
  padding-bottom: calc(10px + env(safe-area-inset-bottom));
  background: #fff;
  box-shadow: 0 -6px 16px rgba(0, 0, 0, 0.06);
  z-index: 1000;
}

:deep(.van-button--primary) {
  background: var(--mg-orange);
  border-color: var(--mg-orange);
}

:deep(.van-button--primary.van-button--plain) {
  color: var(--mg-orange);
  background: #fff;
}

:deep(.van-tab--active) {
  color: var(--mg-orange);
}

:deep(.van-tabs__line) {
  background: var(--mg-orange);
}

:deep(.van-tabs__wrap) {
  height: 34px;
}

.status-tag {
  border: 1px solid transparent;
  font-size: 12px;
  padding: 0 6px;
  line-height: 18px;
}

.status-booking {
  color: var(--mg-orange);
  background: rgba(242, 124, 52, 0.12);
  border-color: rgba(242, 124, 52, 0.35);
}

.status-pending {
  color: #6b7280;
  background: rgba(107, 114, 128, 0.12);
  border-color: rgba(107, 114, 128, 0.35);
}

.status-arrive {
  color: var(--mg-cyan);
  background: rgba(74, 178, 194, 0.12);
  border-color: rgba(74, 178, 194, 0.35);
}

.status-deal {
  color: var(--mg-green);
  background: rgba(146, 186, 63, 0.14);
  border-color: rgba(146, 186, 63, 0.38);
}

.status-cancel {
  color: var(--mg-pink);
  background: rgba(214, 93, 140, 0.12);
  border-color: rgba(214, 93, 140, 0.35);
}

.card {
  padding: 12px 14px 12px;
  margin: 0 0 10px;
  border-radius: 14px;
  background: #fff;
  border: 1px solid rgba(74, 178, 194, 0.14);
  box-shadow: 0 4px 12px rgba(30, 35, 90, 0.05);
  cursor: pointer;
}

.booking-card {
  --accent-color: rgba(150, 151, 153, 0.55);
  --accent-wash: rgba(150, 151, 153, 0.1);
  position: relative;
  overflow: hidden;
  padding-left: 24px;
}

.booking-card::before {
  content: "";
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  width: 20px;
  background: linear-gradient(90deg, var(--accent-wash) 0%, rgba(255, 255, 255, 0) 100%);
}

.booking-card::after {
  content: "";
  position: absolute;
  left: 6px;
  top: 9px;
  bottom: 9px;
  width: 4px;
  border-radius: 999px;
  background: var(--accent-color);
}

.booking-card.status-booking {
  --accent-color: rgba(242, 124, 52, 0.72);
  --accent-wash: rgba(242, 124, 52, 0.12);
}

.booking-card.status-pending {
  --accent-color: rgba(107, 114, 128, 0.65);
  --accent-wash: rgba(107, 114, 128, 0.12);
}

.booking-card.status-arrive {
  --accent-color: rgba(74, 178, 194, 0.72);
  --accent-wash: rgba(74, 178, 194, 0.12);
}

.booking-card.status-deal {
  --accent-color: rgba(146, 186, 63, 0.76);
  --accent-wash: rgba(146, 186, 63, 0.12);
}

.booking-card.status-cancel {
  --accent-color: rgba(214, 93, 140, 0.72);
  --accent-wash: rgba(214, 93, 140, 0.12);
}

.booking-card-top {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
}

.booking-student {
  display: flex;
  align-items: baseline;
  gap: 8px;
  min-width: 0;
}

.booking-student-name {
  font-size: 16px;
  font-weight: 600;
  color: #323233;
  max-width: 180px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.booking-student-age {
  font-size: 13px;
  color: #969799;
  flex: 0 0 auto;
}

.booking-student-gender {
  font-size: 12px;
  color: #969799;
  flex: 0 0 auto;
}

.booking-parent {
  margin-top: 8px;
  font-size: 13px;
  color: #646566;
  display: flex;
  align-items: center;
  gap: 6px;
  min-width: 0;
}

.booking-parent-label {
  color: #969799;
  flex: 0 0 auto;
}

.booking-parent-name {
  color: #323233;
  max-width: 120px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.booking-parent-mobile {
  color: #323233;
  flex: 1 1 auto;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.booking-remark {
  margin-top: 8px;
  font-size: 13px;
  color: #8c8f96;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  word-break: break-all;
}

.row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  line-height: 20px;
  font-size: 13px;
  color: #646566;
}

.label {
  color: #969799;
  margin-right: 12px;
  flex: 0 0 auto;
}

.value {
  text-align: right;
  flex: 1 1 auto;
}

.flow-actions {
  margin-top: 10px;
  padding-top: 10px;
  border-top: 1px solid #f2f3f5;
  display: flex;
}

.flow-step {
  flex: 1 1 0;
  height: 32px;
  border: none;
  color: #8c8f96;
  font-size: 12px;
  font-weight: 600;
  background: #e7e8ec;
  position: relative;
  cursor: pointer;
  clip-path: polygon(0 0, calc(100% - 12px) 0, 100% 50%, calc(100% - 12px) 100%, 0 100%, 12px 50%);
}

.flow-step:first-child {
  clip-path: polygon(0 0, calc(100% - 12px) 0, 100% 50%, calc(100% - 12px) 100%, 0 100%);
}

.flow-step:last-child {
  clip-path: polygon(0 0, 100% 0, 100% 100%, 0 100%, 12px 50%);
}

.flow-step.active {
  color: #fff;
  background: var(--mg-orange);
}

.flow-step:disabled {
  opacity: 1;
}

.dialog-body {
  padding: 8px 0;
}

.detail-popup {
  height: 100%;
  display: flex;
  flex-direction: column;
  background: #f6f7fb;
}

.detail-popup-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 18px 12px;
  background: #f6f7fb;
}

.detail-popup-title {
  font-size: 26px;
  font-weight: 700;
  color: #323233;
}

.detail-popup-close {
  font-size: 22px;
  color: #7d7f86;
}

.detail-popup-scroll {
  flex: 1;
  min-height: 0;
  overflow-y: auto;
  padding: 0 14px 20px;
}

.detail-main-card {
  position: relative;
  background: #f2f2ee;
  border-radius: 14px;
  padding: 16px 14px 12px;
}

.detail-main-status {
  position: absolute;
  right: 12px;
  top: 12px;
}

.detail-student {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 12px;
}

.detail-avatar {
  width: 72px;
  height: 72px;
  border-radius: 50%;
  background: #6f9768;
  color: #fff;
  font-size: 30px;
  font-weight: 700;
  display: flex;
  align-items: center;
  justify-content: center;
}

.detail-student-name {
  font-size: 24px;
  font-weight: 700;
  color: #323233;
  line-height: 1.1;
}

.detail-student-age {
  font-size: 14px;
  color: #7d7f86;
}

.detail-student-gender {
  margin-top: 2px;
  font-size: 14px;
  color: #7d7f86;
}

.detail-student-birth {
  font-size: 14px;
  color: #7d7f86;
}

.detail-student-age-birth {
  margin-top: 2px;
  display: flex;
  align-items: center;
  gap: 8px;
}

.detail-kv {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 8px;
  font-size: 16px;
}

.detail-kv-label {
  color: #7d7f86;
}

.detail-kv-value {
  color: #323233;
  font-weight: 600;
  text-align: right;
  margin-left: 10px;
}

.detail-section-title {
  margin: 16px 2px 10px;
  font-size: 16px;
  color: #323233;
  font-weight: 700;
}

.detail-info-list {
  background: #fff;
  border-radius: 10px;
  padding: 8px 12px;
}

.detail-info-list .detail-kv {
  margin-top: 0;
  padding: 6px 0;
}

.detail-remark-block {
  background: #fff;
  border-radius: 10px;
  padding: 12px;
  min-height: 68px;
  color: #595b62;
  font-size: 14px;
  line-height: 1.45;
  white-space: pre-wrap;
  word-break: break-all;
}

.detail-actions {
  margin-top: 0;
  display: flex;
  flex-direction: row;
  gap: 8px;
  padding: 12px 16px calc(12px + env(safe-area-inset-bottom));
  border-top: 1px solid #ebedf0;
  background: #fff;
}

.detail-actions :deep(.van-button) {
  flex: 1;
}

.popup-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 14px 16px;
  border-bottom: 1px solid #ebedf0;
}

.popup-title {
  font-size: 16px;
  font-weight: 600;
}

.popup-close {
  font-size: 18px;
  color: #969799;
}

.popup-actions {
  padding: 16px;
  width: 100%;
  position: absolute;
  bottom: 0;
  box-sizing: border-box;
}

.booking-popup-wrap {
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow: hidden;
}

.booking-popup-scroll {
  flex: 1;
  min-height: 0;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
}

.booking-popup-actions {
  position: absolute;
  width: 100%;
  bottom: 0;
  padding: 16px 16px 20px;
  box-sizing: border-box;
}

.update-popup-wrap {
  max-height: 82vh;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.update-popup-scroll {
  flex: 1;
  min-height: 0;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  padding-bottom: 8px;
}

.update-popup-actions {
  padding: 12px 16px calc(12px + env(safe-area-inset-bottom));
  background: #fff;
  border-top: 1px solid #ebedf0;
}

.assign-assistant-popup {
  height: 100%;
  display: flex;
  flex-direction: column;
}

.assign-assistant-body {
  flex: 1;
  min-height: 0;
  overflow-y: auto;
  padding: 10px 0 calc(84px + env(safe-area-inset-bottom));
  -webkit-overflow-scrolling: touch;
}

.assign-assistant-actions {
  padding: 12px 16px calc(12px + env(safe-area-inset-bottom));
  background: #fff;
  border-top: 1px solid #ebedf0;
  box-sizing: border-box;
}
</style>

